import React from 'react';
import { Rect } from 'react-konva';
import { mergeRefs } from '../../../../utils/mergeRef';
import { ShapeCommonProps } from '../../types';
import { useShape } from '../ShapeContext/useShape';

export const RectShape = React.forwardRef<
  React.ElementRef<typeof Rect>,
  ShapeCommonProps
>((commonProps, ref) => {
  const { isHovered, shape, isInSelection } = useShape();

  const shapeRef = React.useRef<React.ElementRef<typeof Rect>>(null);

  return (
    <Rect
      {...commonProps}
      width={shape.width}
      height={shape.height}
      fill={shape.color}
      stroke={
        !shape.locked && (isHovered || isInSelection)
          ? '#000000'
          : 'transparent'
      }
      strokeWidth={0.5}
      opacity={shape.locked ? 0.5 : 1}
      ref={mergeRefs([shapeRef, ref])}
      cornerRadius={shape.cornerRadius || 0}
    />
  );
});
